var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { BaseTemplate } from "./base-template";
import { Client } from "../../../views/app/client/client";
import { RouterConstants } from "../../../configuration/router.constants";
import * as Enumerable from "linq";
import { NotificationType } from "../../../services/basics/notification-client.service";
import moment from "moment";
var BasePurchases = /** @class */ (function (_super) {
    __extends(BasePurchases, _super);
    function BasePurchases(router, lotteryClientService, eventAggregator, hotLotteryClientService, notificationClientService, tokenClient, i18N, dialogClientService) {
        var _this = _super.call(this, router, i18N, lotteryClientService, dialogClientService, tokenClient) || this;
        _this.lotteryClientService = lotteryClientService;
        _this.eventAggregator = eventAggregator;
        _this.hotLotteryClientService = hotLotteryClientService;
        _this.notificationClientService = notificationClientService;
        _this.currentPage = 0;
        _this.items = [];
        _this.hotLotteries = [];
        _this.loadingPurchases = true;
        _this.transactionId = null;
        _this.lotteryId = null;
        _this.filter = null;
        _this.isLoadingPurchases = false;
        _this.onKeyDown = function (event) {
            if (event.keyCode == 13) // Enter
             {
                event.stopPropagation();
                _this.currentPage = 0;
                _this.items = [];
                _this.loadPurchasedItems();
            }
        };
        _this.defaultUserCurrencySymbol = tokenClient.getUserCurrency().symbol;
        return _this;
    }
    BasePurchases.prototype.activate = function (params) {
        var _this = this;
        this.transactionId = params.transactionId;
        this.lotteryId = params.lotteryId;
        if (!this.tokenClient.isAuthenticated && !this.tokenClient.isPreview) {
            this.router.navigateToRoute(RouterConstants.RouteNames.Lobby, {});
        }
        else {
            var promise = _super.prototype.activate.call(this, params);
            this.currentPage = 0;
            this.items = [];
            this.loadPurchasedItems();
            this.hotLotteryClientService.getHotLotteries().then(function (x) {
                _this.hotLotteries = x;
            }, function (x) {
                _this.notificationClientService.show("Error", _this.i18n.tr(x.response), NotificationType.Error);
            });
            return promise;
        }
    };
    BasePurchases.prototype.loadPurchasedItems = function () {
        var _this = this;
        if (this.isLoadingPurchases)
            return;
        this.isLoadingPurchases = true;
        if (this.moreToLoad) {
            this.loadingMore = true;
        }
        this.lotteryClientService.getMyPurchases(this.currentPage, this.transactionId, this.filter, this.lotteryId).then(function (x) {
            var e_1, _a;
            _this.moreToLoad = x.moreToLoad;
            try {
                for (var _b = __values(x.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    item.tickets = Enumerable.from(item.tickets).orderBy(function (x) { return new Date(x.drawDate); }).toArray();
                    _this.items.push(item);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            _this.loadingPurchases = false;
            _this.loadingMore = false;
            if (_this.currentPage == 0) // clear count if page is the first one
                _this.eventAggregator.publish(Client.UpdatePurchaseCount);
            _this.isLoadingPurchases = false;
        }, function (x) {
            _this.isLoadingPurchases = false;
            _this.notificationClientService.show("Error", _this.i18n.tr(x.response), NotificationType.Error);
        });
    };
    BasePurchases.prototype.attached = function () {
        _super.prototype.attached.call(this);
        if (this.searchinput)
            this.searchinput.addEventListener("keydown", this.onKeyDown, false);
    };
    BasePurchases.prototype.detached = function () {
        _super.prototype.detached.call(this);
        if (this.searchinput)
            this.searchinput.removeEventListener("keydown", this.onKeyDown, false);
    };
    BasePurchases.prototype.loadMore = function () {
        this.currentPage += 1;
        this.loadPurchasedItems();
    };
    BasePurchases.prototype.toggleTickets = function (item) {
        item.ticketsAreVisible = !item.ticketsAreVisible;
    };
    BasePurchases.prototype.navigateToLottery = function (lottery) {
        var key = this.getLotteryKey(lottery.lotteryName);
        this.router.navigateToRoute(RouterConstants.RouteNames.Lottery, {
            lotteryId: lottery.lotteryId,
            key: key,
            brandLotteryId: lottery.brandLotteryId
        });
        window.dataLayer.push({
            "event": "navigate_lottery",
            "openedLotteryId": lottery.lotteryId,
            "openedLotteryName": lottery.lotteryName
        });
    };
    BasePurchases.prototype.showTicketDialog = function (item) {
        var templateName = this.tokenClient.user.templateName.toLowerCase();
        try {
            require("./" + templateName + "/dialogs/ticket-dialog");
        }
        catch (_a) {
            console.log("Cannot load ticket dialog for template " + templateName);
        }
        this.dialogClient.show("app/styles/client/templates/" + templateName + "/dialogs/ticket-dialog", item, true, true);
    };
    BasePurchases.prototype.getDrawDate = function (item) {
        var dates = Enumerable.from(item.tickets).select(function (x) { return new Date(x.drawDate); });
        var from = dates.orderBy(function (x) { return x; }).firstOrDefault();
        var to = dates.orderByDescending(function (x) { return x; }).firstOrDefault();
        var fromStr = moment(from).format("MMM Do YYYY HH:mm:ss");
        var toStr = moment(to).format("MMM Do YYYY HH:mm:ss");
        if (fromStr == toStr)
            return fromStr;
        return "".concat(fromStr, " - ").concat(toStr);
    };
    BasePurchases.prototype.getCreditedDateDate = function (item) {
        if (item.creditedDate) {
            var creditedDate = moment(new Date(item.creditedDate)).format("MMM Do YYYY HH:mm:ss");
            return creditedDate;
        }
        return "";
    };
    BasePurchases.prototype.getResults = function (item) {
        return item.lastDrawResults;
    };
    BasePurchases.prototype.toggleSearch = function () {
        this.searchOpened = !this.searchOpened;
        if (this.searchOpened) {
            this.searchinput.focus();
        }
    };
    BasePurchases.prototype.clearSearch = function () {
        this.filter = "";
        this.currentPage = 0;
        this.items = [];
        this.loadPurchasedItems();
    };
    return BasePurchases;
}(BaseTemplate));
export { BasePurchases };
